import { BackupTranslationInterface } from 'app/site-settings/models/backup-translation.model';
import { CustomFieldInterface } from 'app/site-settings/models/custom-field.model';
import { LicenseDataInterface } from 'app/site-settings/models/license-data.model';
import { PasswordSettingsInterface } from 'app/site-settings/models/password-settings.model';
import { SiteEmailConfigInterface } from 'app/site-settings/models/site-email-config.model';
import { SiteSettingInterface } from 'app/site-settings/models/site-setting.model';
import { SiteSupportedLanguageInterface } from 'app/site-settings/models/site-supported-language.model';
import { UserSessionSettingsInterface } from 'app/site-settings/models/usersession-settings.model';
import { ActiveInterface } from 'app/site-settings/models/active.model';
import { MessageBannerInterface, MessageInterface, MessageTextInterface } from 'app/site-settings/models/message-banner.model';
import { ErrorsSSOInterface, ErrorSSOSingleInterface } from 'app/site-settings/models/error-message';
import { SSOStatusInterface } from 'app/site-settings/models/active.model';
import { SSOMetadataInterface } from 'app/site-settings/models/sso-metadata.model';

export interface SiteSettingsStateInterface {
  settingsCollection?: SiteSettingInterface[];
  customFieldsCollection?: CustomFieldInterface[];
  siteEmailConfig?: SiteEmailConfigInterface;
  siteLicenseData?: LicenseDataInterface;
  licenseUpdateResponse?: string;
  siteSupportedLanguageCollection?: SiteSupportedLanguageInterface[];
  backupTranslationResponse?: BackupTranslationInterface;
  passwordSettingsResponse?: PasswordSettingsInterface;
  messageBanner?: MessageBannerInterface;
  singleMessageBanner?: MessageInterface;
  messageTextBanner?: MessageTextInterface;
  errorsSSO?: ErrorsSSOInterface[];
  errorsSingleSSO?: ErrorSSOSingleInterface;
  active?: ActiveInterface;
  userProps?: SSOStatusInterface;
  userSessionSettingsResponse?: UserSessionSettingsInterface;
  ssoKeyValid?: any;
  ssoMetadata?: SSOMetadataInterface;
}

export class SiteSettingsState implements SiteSettingsStateInterface {
  public settingsCollection?: SiteSettingInterface[];
  public customFieldsCollection?: CustomFieldInterface[];
  public siteEmailConfig?: SiteEmailConfigInterface;
  public siteLicenseData?: LicenseDataInterface;
  public licenseUpdateResponse?: string;
  public siteSupportedLanguageCollection?: SiteSupportedLanguageInterface[];
  public backupTranslationResponse?: BackupTranslationInterface;
  public passwordSettingsResponse?: PasswordSettingsInterface;
  public messageBanner?: MessageBannerInterface;
  public singleMessageBanner?: MessageInterface;
  public messageTextBanner?: MessageTextInterface;
  public errorsSSO?: ErrorsSSOInterface[];
  public errorsSingleSSO?: ErrorSSOSingleInterface;
  public userProps?: SSOStatusInterface;
  public active?: ActiveInterface;
  public ssoKeyValid?: any;
  public ssoMetadata?: any;
  constructor({
    settingsCollection = undefined,
    customFieldsCollection = undefined,
    siteEmailConfig = undefined,
    siteLicenseData = undefined,
    licenseUpdateResponse = undefined,
    siteSupportedLanguageCollection = undefined,
    backupTranslationResponse = undefined,
    passwordSettingsResponse = undefined,
    messageBanner = undefined,
    singleMessageBanner = undefined,
    errorsSSO = undefined,
    errorsSingleSSO = undefined,
    messageTextBanner = undefined,
    userProps = undefined,
    active = undefined,
    ssoKeyValid = undefined,
    ssoMetadata = undefined,
  }: SiteSettingsStateInterface) {
    this.settingsCollection = settingsCollection;
    this.customFieldsCollection = customFieldsCollection;
    this.siteEmailConfig = siteEmailConfig;
    this.siteLicenseData = siteLicenseData;
    this.licenseUpdateResponse = licenseUpdateResponse;
    this.siteSupportedLanguageCollection = siteSupportedLanguageCollection;
    this.backupTranslationResponse = backupTranslationResponse;
    this.passwordSettingsResponse = passwordSettingsResponse;
    this.messageBanner = messageBanner;
    this.singleMessageBanner = singleMessageBanner;
    this.errorsSSO = errorsSSO;
    this.messageTextBanner = messageTextBanner;
    this.errorsSingleSSO = errorsSingleSSO;
    this.userProps = userProps;
    this.active = active;
    this.ssoKeyValid = ssoKeyValid;
    this.ssoMetadata = ssoMetadata;
  }
}
